module.exports = "<div class=\"ui segment full-height\">\r\n  <iframe *ngIf=\"announcement?.url\" [src]=\"trustUrl(announcement.url)\"></iframe>\r\n</div>\r\n\r\n<!--{{announcement}}-->"


//////////////////
// WEBPACK FOOTER
// /ng-app/src/app/announcements/announcement-detail/announcement-detail.component.html
// module id = ../../../../../src/app/announcements/announcement-detail/announcement-detail.component.html
// module chunks = main